import { possessive } from '@shared';
import { Button, Spinner, Textarea } from '@design-system';

import { Check } from 'lucide-react';

import { useState } from 'react';

import { useFreemiumDetails } from '../hooks/use-freemium-details';

interface CaseDetailsFieldProps {
  clientId: string;
  clientFirstName: string;
}

export function CaseDetailsField({ clientId, clientFirstName }: CaseDetailsFieldProps) {
  const [details, setDetails] = useState('');
  const { mutate, isPending, isSuccess } = useFreemiumDetails(clientId);
  const canSubmit = details.trim().length > 0 && !isPending;

  if (isSuccess) {
    return (
      <div className="border-primary/30 bg-primary/5 text-foreground flex items-start gap-2 rounded-lg border p-4 text-sm">
        <Check className="text-primary mt-0.5 size-4 shrink-0" />
        <span>Thanks - we&apos;ve shared these details with the team.</span>
      </div>
    );
  }

  return (
    <div className="text-start">
      <p className="text-foreground font-medium">
        Anything we should know about {possessive(clientFirstName)} situation?
      </p>
      <Textarea
        className="mt-3 min-h-32"
        placeholder="Share as much detail as you'd like…"
        value={details}
        onChange={event => setDetails(event.target.value)}
        disabled={isPending}
      />
      <Button
        variant="outline"
        size="lg"
        className="mt-4 w-full"
        disabled={!canSubmit}
        onClick={() => mutate(details)}
      >
        {isPending && <Spinner />}
        Share with our team
      </Button>
    </div>
  );
}
